import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import { Button } from 'components/Atom/Button';
import Select from 'components/Atom/Select';
import DateRangePicker from 'components/Atom/DateRange';
import moment from 'moment';
import './style.css';

import { chargeTypes } from 'utils/constant';

const chargeTypeOptions = [
  { label: 'All', value: 'all' },
  { label: 'Standard', value: chargeTypes.STANDARD },
  { label: 'Tiered', value: chargeTypes.TIERED },
  { label: 'Volume', value: chargeTypes.VOLUME },
  { label: 'Percentage', value: chargeTypes.PERCENTAGE },
  { label: 'Composite', value: chargeTypes.COMPOSITE },
];

const typeOptions = [
  { label: 'All', value: 'all' },
  { label: 'One-time', value: 'one-time' },
  { label: 'Recurring', value: 'recurring' },
];

const operatorOptions = [
  { label: 'All', value: 'all' },
  { label: 'AND', value: 'AND' },
  { label: 'OR', value: 'OR' },
];

const orStrategyOptions = [
  { label: 'All', value: 'all' },
  { label: 'Higher', value: 'higher' },
  { label: 'Lower', value: 'lower' },
];

const getSelectValue = (options, selectedValue) => options?.find((item) => item?.value === (selectedValue ?? 'all')) ?? options[0];

const Filter = ({ filtersData, handleClose, onSearch }) => {
  const [filterData, setFilterData] = useState(filtersData || {});

  useEffect(() => {
    setFilterData(filtersData || {});
  }, [filtersData]);

  const handleOnChangeValue = (value, type) => {
    if (type === 'date_range') {
      if (!value || value?.length === 0) {
        setFilterData((prev) => {
          const next = { ...prev };
          delete next[type];
          return next;
        });
      } else {
        setFilterData((prev) => ({ ...prev, [type]: value }));
      }
      return;
    }

    const normalized = value ?? 'all';
    if (normalized === 'all') {
      setFilterData((prev) => {
        const next = { ...prev };
        delete next[type];
        return next;
      });
    } else {
      setFilterData((prev) => ({ ...prev, [type]: normalized }));
    }
  };

  const handleApplyFilters = () => {
    if (Object.keys(filterData ?? {})?.length > 0 || Object.keys(filtersData ?? {})?.length > 0) {
      onSearch(filterData);
      handleClose();
    } else {
      handleClose();
    }
  };

  return (
    <div style={{ width: '100%', marginTop: '1rem', marginBottom: '0.75rem' }}>
      <Form layout='vertical'>
        <div className='formContainer transaction-filter transaction-modal'>
          <div>
            <Form.Item label='Charge Type' className='modalField font-bold mb-[0px]'>
              <Select
                optionsValue={chargeTypeOptions}
                value={getSelectValue(chargeTypeOptions, filterData?.charge_type)}
                handleChange={(e) => handleOnChangeValue(e?.value ?? e, 'charge_type')}
                placeholder='Select'
                style={{ width: '100%' }}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item label='Model Type' className='modalField font-bold mb-[0px]'>
              <Select
                optionsValue={typeOptions}
                value={getSelectValue(typeOptions, filterData?.type)}
                handleChange={(e) => handleOnChangeValue(e?.value ?? e, 'type')}
                placeholder='Select'
                style={{ width: '100%' }}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item label='Combination Operator' className='modalField font-bold mb-[0px]'>
              <Select
                optionsValue={operatorOptions}
                value={getSelectValue(operatorOptions, filterData?.combination_operator)}
                handleChange={(e) => handleOnChangeValue(e?.value ?? e, 'combination_operator')}
                placeholder='Select'
                style={{ width: '100%' }}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item label='Whichever  Strategy' className='modalField font-bold mb-[0px]'>
              <Select
                optionsValue={orStrategyOptions}
                value={getSelectValue(orStrategyOptions, filterData?.or_strategy)}
                handleChange={(e) => handleOnChangeValue(e?.value ?? e, 'or_strategy')}
                placeholder='Select'
                style={{ width: '100%' }}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item className='modalField font-bold mb-[0px]' label='Date Range'>
              <DateRangePicker
                defaultValue={filtersData?.date_range ? [moment(filtersData?.date_range[0]), moment(filtersData?.date_range[1])] : null}
                value={filterData?.date_range ?? null}
                hideButton={true}
                onChange={(e) => handleOnChangeValue(e, 'date_range')}
              />
            </Form.Item>
          </div>
        </div>
        <div className='binClass mt-1'>
          <div className='float-start filter-btn'>
            <Button onClick={handleApplyFilters}>Apply</Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Filter;
